import React from "react";

// import { FilterCheckBox, FilterTabs, FilterRadio, FilterDate } from "../Filters";
function tooltip(tooltip) {
  if (tooltip) return <i className="info-icon tooltip tooltip-bottom tooltip-xs-right pl-1" data-tooltip={tooltip}></i>
  else return null
}

export const FormInputSelect = props => <>
  <label for="e-input-3"><strong>{props.label} {props.required ? <i class="color-categorical-5">*</i> : null}</strong>  {tooltip(props.tooltip)}</label>
  <select id={props.id} name={props.name} onChange={props.onChange} value={props.selected} disabled={props.disabled}>
    {(() => { if (props.empty_option) return <option value="" selected></option> })()}
    {props.options.map(option => {
      if (option.value === props.selected) {
        return <option value={option.value} selected>{option.label}</option>
      }
      else {
        return <option value={option.value}>{option.label}</option>
      }
    })}
  </select></>
